import { useI18n } from "@/i18n/i18n";
import { Languages } from "lucide-react";

export default function LanguageToggle({ className = "", compact = false }) {
  const { lang, toggle } = useI18n();
  return (
    <button
      onClick={toggle}
      className={`inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] hover:border-[color:var(--mc-cyan)] hover:text-[color:var(--mc-cyan)] text-white/85 transition-colors ${
        compact ? "h-9 px-3 text-xs" : "h-10 px-4 text-sm"
      } ${className}`}
      aria-label="Toggle language"
      data-testid="lang-toggle"
    >
      <Languages className="h-4 w-4" />
      <span className="font-semibold tracking-wider">
        {lang === "es" ? "EN" : "ES"}
      </span>
    </button>
  );
}
